module.exports = __webpack_public_path__ + "fonts/AudiType-Italic_4.03.92aff5c4.woff";